import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowUpRight,FiInstagram} = FiIcons;

function MaintenancePage({onAdmin}) {
  return (
    <main className="maintenance-page">
      <div className="maintenance-mark">C</div>
      <span className="eyebrow">Girl In Paris</span>
      <p className="script-kicker">A new chapter is almost here</p>
      <h1>We are making<br />something beautiful.</h1>
      <p className="maintenance-copy">
        Our little corner of Paris is being refreshed. Come back soon for new
        stories, considered objects, and a fresh reason to begin again.
      </p>
      <div className="maintenance-actions">
        <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
          Follow along on Instagram
          <SafeIcon icon={FiInstagram} />
        </a>
        <button onClick={onAdmin} className="maintenance-admin-link">
          Admin access
          <SafeIcon icon={FiArrowUpRight} />
        </button>
      </div>
      <span className="maintenance-caption">Paris · New York · Everywhere she is becoming</span>
    </main>
  );
}

export default MaintenancePage;